const translate_pt = {
  translation: {
    // códigos de discagem
    countryCodes: {
      // especiais
      AC: 'Ilha de Ascensão',
      TA: 'Tristão da Cunha',
      XK: 'Kosovo',
      // oficiais
      AD: 'Andorra',
      AE: 'Emirados Árabes Unidos',
      AF: 'Afeganistão',
      AG: 'Antígua e Barbuda',
      AI: 'Anguila',
      AL: 'Albânia',
      AM: 'Armênia',
      AO: 'Angola',
      AQ: 'Antártica',
      AR: 'Argentina',
      AS: 'Samoa Americana',
      AT: 'Áustria',
      AU: 'Austrália',
      AW: 'Aruba',
      AX: 'Ilhas Åland',
      AZ: 'Azerbaijão',
      BA: 'Bósnia e Herzegovina',
      BB: 'Barbados',
      BD: 'Bangladesh',
      BE: 'Bélgica',
      BF: 'Burkina Faso',
      BG: 'Bulgária',
      BH: 'Bahrein',
      BI: 'Burundi',
      BJ: 'Benin',
      BL: 'São Bartolomeu',
      BM: 'Bermudas',
      BN: 'Brunei',
      BO: 'Bolívia',
      BQ: 'Bonaire, Santo Eustáquio e Saba',
      BR: 'Brasil',
      BS: 'Bahamas',
      BT: 'Butão',
      BV: 'Ilha Bouvet',
      BW: 'Botsuana',
      BY: 'Bielorrússia',
      BZ: 'Belize',
      CA: 'Canadá',
      CC: 'Ilhas Cocos (Keeling)',
      CD: 'Congo (República Democrática)',
      CF: 'República Centro-Africana',
      CG: 'Congo',
      CH: 'Suíça',
      CI: 'Costa do Marfim',
      CK: 'Ilhas Cook',
      CL: 'Chile',
      CM: 'Camarões',
      CN: 'China',
      CO: 'Colômbia',
      CR: 'Costa Rica',
      CU: 'Cuba',
      CV: 'Cabo Verde',
      CW: 'Curaçao',
      CX: 'Ilha Christmas',
      CY: 'Chipre',
      CZ: 'República Tcheca',
      DE: 'Alemanha',
      DJ: 'Djibuti',
      DK: 'Dinamarca',
      DM: 'Dominica',
      DO: 'República Dominicana',
      DZ: 'Argélia',
      EC: 'Equador',
      EE: 'Estônia',
      EG: 'Egito',
      EH: 'Saara Ocidental',
      ER: 'Eritreia',
      ES: 'Espanha',
      ET: 'Etiópia',
      FI: 'Finlândia',
      FJ: 'Fiji',
      FK: 'Ilhas Malvinas',
      FM: 'Micronésia',
      FO: 'Ilhas Faroé',
      FR: 'França',
      GA: 'Gabão',
      GB: 'Reino Unido',
      GD: 'Granada',
      GE: 'Geórgia',
      GF: 'Guiana Francesa',
      GG: 'Guernsey',
      GH: 'Gana',
      GI: 'Gibraltar',
      GL: 'Groenlândia',
      GM: 'Gâmbia',
      GN: 'Guiné',
      GP: 'Guadalupe',
      GQ: 'Guiné Equatorial',
      GR: 'Grécia',
      GS: 'Ilhas Geórgia do Sul e Sandwich do Sul',
      GT: 'Guatemala',
      GU: 'Guam',
      GW: 'Guiné-Bissau',
      GY: 'Guiana',
      HK: 'Hong Kong',
      HM: 'Ilhas Heard e McDonald',
      HN: 'Honduras',
      HR: 'Croácia',
      HT: 'Haiti',
      HU: 'Hungria',
      ID: 'Indonésia',
      IE: 'Irlanda',
      IL: 'Israel',
      IM: 'Ilha de Man',
      IN: 'Índia',
      IO: 'Território Britânico do Oceano Índico',
      IQ: 'Iraque',
      IR: 'Irã',
      IS: 'Islândia',
      IT: 'Itália',
      JE: 'Jersey',
      JM: 'Jamaica',
      JO: 'Jordânia',
      JP: 'Japão',
      KE: 'Quênia',
      KG: 'Quirguistão',
      KH: 'Camboja',
      KI: 'Kiribati',
      KM: 'Comores',
      KN: 'São Cristóvão e Nevis',
      KP: 'Coreia do Norte',
      KR: 'Coreia do Sul',
      KW: 'Kuwait',
      KY: 'Ilhas Cayman',
      KZ: 'Cazaquistão',
      LA: 'Laos',
      LB: 'Líbano',
      LC: 'Santa Lúcia',
      LI: 'Liechtenstein',
      LK: 'Sri Lanka',
      LR: 'Libéria',
      LS: 'Lesoto',
      LT: 'Lituânia',
      LU: 'Luxemburgo',
      LV: 'Letônia',
      LY: 'Líbia',
      MA: 'Marrocos',
      MC: 'Mônaco',
      MD: 'Moldávia',
      ME: 'Montenegro',
      MF: 'São Martinho (parte francesa)',
      MG: 'Madagascar',
      MH: 'Ilhas Marshall',
      MK: 'Macedônia do Norte',
      ML: 'Mali',
      MM: 'Mianmar',
      MN: 'Mongólia',
      MO: 'Macau',
      MP: 'Ilhas Marianas do Norte',
      MQ: 'Martinica',
      MR: 'Mauritânia',
      MS: 'Montserrat',
      MT: 'Malta',
      MU: 'Maurícia',
      MV: 'Maldivas',
      MW: 'Malaui',
      MX: 'México',
      MY: 'Malásia',
      MZ: 'Moçambique',
      NA: 'Namíbia',
      NC: 'Nova Caledônia',
      NE: 'Níger',
      NF: 'Ilha Norfolk',
      NG: 'Nigéria',
      NI: 'Nicarágua',
      NL: 'Países Baixos',
      NO: 'Noruega',
      NP: 'Nepal',
      NR: 'Nauru',
      NU: 'Niue',
      NZ: 'Nova Zelândia',
      OM: 'Omã',
      PA: 'Panamá',
      PE: 'Peru',
      PF: 'Polinésia Francesa',
      PG: 'Papua-Nova Guiné',
      PH: 'Filipinas',
      PK: 'Paquistão',
      PL: 'Polônia',
      PM: 'São Pedro e Miquelão',
      PN: 'Pitcairn',
      PR: 'Porto Rico',
      PS: 'Palestina',
      PT: 'Portugal',
      PW: 'Palau',
      PY: 'Paraguai',
      QA: 'Catar',
      RE: 'Reunião',
      RO: 'Romênia',
      RS: 'Sérvia',
      RU: 'Rússia',
      RW: 'Ruanda',
      SA: 'Arábia Saudita',
      SB: 'Ilhas Salomão',
      SC: 'Seicheles',
      SD: 'Sudão',
      SE: 'Suécia',
      SG: 'Singapura',
      SH: 'Santa Helena, Ascensão e Tristão da Cunha',
      SI: 'Eslovênia',
      SJ: 'Svalbard e Jan Mayen',
      SK: 'Eslováquia',
      SL: 'Serra Leoa',
      SM: 'San Marino',
      SN: 'Senegal',
      SO: 'Somália',
      SR: 'Suriname',
      SS: 'Sudão do Sul',
      ST: 'São Tomé e Príncipe',
      SV: 'El Salvador',
      SX: 'Sint Maarten (parte holandesa)',
      SY: 'Síria',
      SZ: 'Essuatíni',
      TC: 'Ilhas Turcas e Caicos',
      TD: 'Chade',
      TF: 'Territórios Franceses do Sul',
      TG: 'Togo',
      TH: 'Tailândia',
      TJ: 'Tajiquistão',
      TK: 'Tokelau',
      TL: 'Timor-Leste',
      TM: 'Turcomenistão',
      TN: 'Tunísia',
      TO: 'Tonga',
      TR: 'Turquia',
      TT: 'Trindade e Tobago',
      TV: 'Tuvalu',
      TW: 'Taiwan',
      TZ: 'Tanzânia',
      UA: 'Ucrânia',
      UG: 'Uganda',
      UM: 'Ilhas Menores Distantes dos Estados Unidos',
      US: 'Estados Unidos',
      UY: 'Uruguai',
      UZ: 'Uzbequistão',
      VA: 'Cidade do Vaticano',
      VC: 'São Vicente e Granadinas',
      VE: 'Venezuela',
      VG: 'Ilhas Virgens Britânicas',
      VI: 'Ilhas Virgens dos Estados Unidos',
      VN: 'Vietnã',
      VU: 'Vanuatu',
      WF: 'Wallis e Futuna',
      WS: 'Samoa',
      YE: 'Iémen',
      YT: 'Mayotte',
      ZA: 'África do Sul',
      ZM: 'Zâmbia',
      ZW: 'Zimbábue'
    },

    // Etiquetas
    labels: {
      lblEmail: 'E-mail *',
      lblOccupation: 'Ocupação *',
      lblNationalID: 'Identidade Nacional *',
      lblNationalIDPlain: 'Identidade Nacional',
      lblDriverLicence: 'Carteira de motorista',
      lblDocumentType: 'Tipo de documento *',
      lblDocumentFront: 'Frente do documento *',
      lblDocumentBack: 'Verso do documento *',
      lblAddressProofOwner: 'O comprovante de endereço está em nome de *',
      lblAddressProofOwnerSelf: 'Acionista / diretor',
      lblAddressProofOwnerOther: 'Outra pessoa',
      lblKinshipDegree: 'Grau de parentesco *',
      lblPassportMockupAlt: 'Exemplo de passaporte',
      lblIdentityMockupAlt: 'Exemplo de identidade nacional',
      lblDocumentExample: 'Exemplo de documento',
      lblSeeExample: 'Ver exemplo',
      lblScanPassport: 'Escanear passaporte',
      lblScanPassportHint: 'Aponte a câmera para a página de dados do passaporte. A leitura acontece sozinha.',
      lblScanPassportPermission: 'Permita o acesso à câmera para escanear o passaporte.',
      lblScanPassportDenied:
        'A permissão da câmera foi recusada. Ative nas configurações do navegador, envie uma foto do documento ou preencha os campos manualmente.',
      lblScanPassportUnavailable: 'Câmera indisponível. Envie uma foto do documento ou preencha os campos manualmente.',
      lblScanPassportPreparing: 'Preparando o leitor...',
      lblScanPassportSearching: 'Procurando os dados do passaporte...',
      lblScanPassportTip: 'Aproxime o passaporte até as duas linhas de baixo preencherem a moldura e evite reflexo.',
      lblScanPassportFailed: 'Não foi possível iniciar o leitor. Tente de novo.',
      lblScanPassportRetry: 'Tentar novamente',
      lblScanPassportUpload: 'Não está dando certo? Envie uma foto do documento',
      lblScanPassportCapture: 'Ler esta imagem',
      lblScanPassportCapturing: 'Lendo a imagem...',
      lblScanPassportReadingPhoto: 'Lendo a foto...',
      lblScanPassportPhotoFailed:
        'Não foi possível ler essa foto. Envie a página de dados nítida, sem reflexo, com as duas linhas de baixo visíveis.',
      lblScanPassportFound: 'Encontramos estes dados',
      lblScanPassportReviewHint:
        'Confira se está tudo certo antes de usar. A leitura pode trocar letras parecidas, como S e B ou G e O.',
      lblScanPassportUseData: 'Usar estes dados',
      lblScanPassportScanAgain: 'Escanear de novo',
      lblPassportExampleTitle: 'Exemplo de passaporte',
      lblIdentityExampleTitle: 'Exemplo de identidade nacional',
      lblIdentityOpenHint: 'Envie o documento aberto, com frente e verso visíveis',
      lblIdentityFront: 'Frente',
      lblIdentityBack: 'Verso',
      lblIdentityFrontAlt: 'Frente da identidade',
      lblIdentityBackAlt: 'Verso da identidade',
      lblSharesUnitsRangeHelper: 'Faixa permitida: 1 – 50.000',
      lblLastName: 'Sobrenome *',
      lblFirstName: 'Nome *',
      lblNotification: 'Notificação',
      lblPassword: 'Senha',
      lblConfirmPassword: 'Confirmar Senha',
      lblPronoun: 'Pronome',
      lblLegalPersonality: 'Personalidade legal',
      lblCompanyProfile: 'Perfil da Empresa',
      lblJurisdictions: 'Jurisdição',
      lblMainGoals: 'Meus Objetivos Principais São',
      lblTypeOfCompany: 'Tipo de empresa',
      lblNumDirectors: 'Número de Diretores',
      lblNumMinors: 'Número de Menores de Idade',
      lblNumShareholders: 'Número de Acionistas',
      lblEntityDirectors: 'Diretores da Entidade',
      lblEntityDirectorsNames: 'Nomes dos Diretores da Entidade',
      lblNumShareholdersUnderage: 'Número de Acionistas Menores de Idade',
      lblEntityPronoun: 'Pronome da Entidade',
      lblEntityShareholders: 'Acionistas da Entidade',
      lblEntityShareholdersNames: 'Nomes dos Acionistas da Entidade',
      lblEntityShareholdersUnderage: 'Acionistas Menores de Idade na Entidade',
      lblObjective: 'Objetivo',
      lblPersonality: 'Personalidade',
      lblRegistrationCountry: 'País de Registro',
      lblWhyDidYouChoose: 'Quais são as vantagens desta jurisdição?',
      lblWhyShareholders: `
        <p>Considere nesta conta o número total de acionistas, independentemente de serem diretores ou não, ou se possuem uma participação pequena no negócio.</p>
        <p>Gostaríamos de destacar nossas políticas de <strong>Conhecimento do Cliente (KYC)</strong>, que são rigorosas e estão em conformidade com as leis e regulamentos internacionais. Nosso compromisso é manter um ambiente de negócios seguro e transparente para todos os nossos clientes.</p>

        <h5>Quem pode enfrentar restrições:</h5>

        <p><strong>Pessoas Politicamente Expostas (PPEs)</strong>: Dada a natureza sensível e o potencial risco de corrupção associado às PPEs, é difícil para nossa empresa aprovar tais indivíduos sem verificações rigorosas e extensivas.</p>

        <p><strong>Servidores Públicos</strong>: Aqueles que atuam em funções públicas, especialmente em posições que têm influência sobre decisões financeiras, estão sujeitos a uma análise KYC mais rigorosa e podem não ser aprovados.</p>

        <p><strong>Indivíduos Condenados por Crimes</strong>: Particularmente aqueles condenados por tráfico, crimes financeiros ou outros delitos graves, dificilmente serão aprovados através de nosso processo de KYC.</p>

        <p><strong>Sem Comprovação de Renda</strong>: Clientes que não podem fornecer comprovação adequada de renda ou fonte de fundos também enfrentarão dificuldades em passar por nossas verificações de KYC.</p>

        <h5>Processo de Verificação:</h5>

        <p>Nosso processo de verificação inclui, mas não se limita a, verificação de documentos, análise de antecedentes e conformidade com as listas de sanções internacionais. Fazemos isso para proteger nossos clientes e manter a integridade de nosso ambiente de negócios.</p>

        <p>Se você se enquadra em uma das categorias acima, é aconselhável que esteja ciente de que o processo de verificação pode ser demorado e que a aprovação não é garantida.</p>

      `,
      lblWhyDirectors: `
        <h5>Funções do Diretor</h5>
        <p>Os diretores de uma entidade offshore são responsáveis por supervisionar as operações gerais da empresa e garantir que suas atividades estejam em conformidade com as leis e regulamentos aplicáveis. Suas funções incluem, entre outras, definir objetivos estratégicos, aprovar políticas internas e trabalhar com executivos e funcionários para garantir sua correta implementação. Os diretores também devem proteger os ativos da empresa e agir no melhor interesse da entidade.</p>

        <h5>Políticas de KYC e Conformidade:</h5>
        <p>Desejamos destacar que nossos procedimentos de Know Your Customer (KYC) são rigorosos e estão totalmente alinhados aos padrões internacionais de conformidade. Nossa prioridade é manter um ambiente empresarial seguro e transparente para todos os nossos clientes.</p>

        <h5>Quem Pode Enfrentar Restrições:</h5>
        <p>Determinadas categorias de indivíduos podem estar sujeitas a uma diligência reforçada ou podem não ser aprovadas durante o processo de incorporação:</p>
        <ul>
          <li><strong>Pessoas Politicamente Expostas (PEPs):</strong> Devido ao maior risco associado a atos de corrupção ou abuso de cargos públicos, PEPs exigem verificações extensas de antecedentes. A aprovação pode ser difícil e não é garantida.</li>
          <li><strong>Funcionários Públicos:</strong> Pessoas que desempenham funções públicas — especialmente aquelas com influência sobre decisões financeiras — estão sujeitas a análises de KYC mais rigorosas e podem ser rejeitadas conforme a avaliação de risco.</li>
          <li><strong>Pessoas com Condenações Criminais:</strong> Indivíduos condenados por tráfico, crimes financeiros, fraude ou outros delitos graves provavelmente não atenderão aos nossos requisitos de conformidade.</li>
          <li><strong>Sem Comprovante de Renda ou de Origem dos Fundos:</strong> Solicitantes que não possam fornecer comprovantes adequados de renda ou documentação que demonstre a origem legítima dos fundos podem enfrentar atrasos ou não aprovação.</li>
        </ul>

        <h5>Processo de Verificação:</h5>
        <p>Nosso processo de verificação inclui, entre outros:</p>
        <ul style="list-style: disc; padding-left: 1.5rem; margin: 0.75rem 0 1rem;">
          <li style="margin-bottom: 0.35rem;">verificação de identidade e documentação</li>
          <li style="margin-bottom: 0.35rem;">verificações de antecedentes e integridade</li>
          <li style="margin-bottom: 0.35rem;">revisão de listas internacionais de sanções</li>
          <li>avaliação da origem do patrimônio e da origem dos fundos</li>
        </ul>
        <p>Essas medidas garantem a proteção de todos os clientes e preservam a integridade do nosso ecossistema corporativo.</p>

        <h5>Aviso Importante:</h5>
        <p>Se você se enquadrar em alguma das categorias mencionadas, esteja ciente de que o processo de verificação pode levar mais tempo do que o habitual, e a aprovação não é garantida.</p>
      `,
      lblWhyDidYouChooseDescription: `
        <h5>1. Benefícios fiscais</h5>
        <p><strong>Sem impostos corporativos:</strong> Entidades registradas nas Bahamas, mas que operam fora do país, não estão sujeitas a imposto corporativo, imposto sobre renda ou imposto sobre ganho de capital.</p>
        <p><strong>Sem retenção na fonte:</strong> Não há retenção sobre dividendos, juros ou royalties pagos ao exterior.</p>
        <p><strong>Regime territorial:</strong> Apenas atividades realizadas dentro das Bahamas são tributadas, favorecendo estruturas com operações internacionais.</p>
        <h5>2. Confidencialidade</h5>
        <p><strong>Proteção razoável de informações:</strong> Embora as Bahamas cumpram padrões internacionais de transparência, os dados de diretores e acionistas não são de acesso público, garantindo um nível adequado de privacidade corporativa.</p>
        <h5>3. Ambiente regulatório favorável</h5>
        <p><strong>Legislação moderna e flexível:</strong> O marco legal societário é estável, atualizado e amigável para investidores estrangeiros.</p>
        <p><strong>Estabilidade política e jurídica:</strong> As Bahamas são reconhecidas por sua institucionalidade sólida, proporcionando mais segurança a proprietários e beneficiários.</p>
        <h5>4. Facilidade para fazer negócios</h5>
        <p><strong>Baixas exigências de reporte:</strong> As obrigações de manutenção e envio de informações são mais simples do que em muitas outras jurisdições.</p>
        <p><strong>Incorporação rápida:</strong> O processo pode ser concluído em poucos dias, com trâmites claros e eficientes.</p>
        <h5>5. Infraestrutura profissional</h5>
        <p><strong>Profissionais experientes:</strong> O país possui uma rede consolidada de advogados, contadores e agentes corporativos altamente especializados em estruturas offshore.</p>
        <h5>6. Proteção de ativos</h5>
        <p><strong>Ferramentas robustas:</strong> As estruturas corporativas e os trusts das Bahamas oferecem mecanismos eficazes de proteção patrimonial, dificultando a apreensão de bens por entidades estrangeiras sem o devido processo legal.</p>
        <p><strong>Sem controles cambiais:</strong> Não há restrições relevantes para a movimentação internacional de fundos por entidades offshore.</p>
      `,

      lblWhyDidYouChooseDescriptionDelaware: `
        <h5>Incorpore sua Empresa em Delaware: O Melhor Destino para sua LLC</h5>

        <p><strong>Por que Delaware é a escolha ideal para sua LLC?</strong></p>

        <p>Delaware é a jurisdição preferida por empresários, investidores e empresas globais. Sua combinação única de benefícios fiscais, proteção legal e facilidade de operação faz do estado um dos mais atrativos para a formação de empresas nos Estados Unidos.</p>

        <h5>Benefícios Fiscais Atraentes:</h5>
        <ul>
          <li><strong>Sem Impostos Estaduais sobre Lucros:</strong> Delaware não cobra impostos sobre a renda ou lucros das LLCs que operam fora do estado. Isso significa que sua empresa pode gerar receita globalmente sem se preocupar com impostos estaduais adicionais.</li>
          <li><strong>Sem Impostos de Retenção:</strong> Delaware não cobra impostos sobre dividendos, juros ou royalties pagos para fora do estado, permitindo uma estrutura fiscal altamente eficiente.</li>
        </ul>

        <h5>Confidencialidade e Privacidade:</h5>
        <ul>
          <li><strong>Proteção de Identidade:</strong> Delaware oferece um nível significativo de privacidade. Não é necessário divulgar publicamente os nomes dos membros ou gerentes da empresa.</li>
        </ul>

        <h5>Ambiente Regulatório Favorável:</h5>
        <ul>
          <li><strong>Leis Societárias Flexíveis e Favoráveis aos Negócios:</strong> A legislação de Delaware é altamente adaptável e incentiva o crescimento e a inovação.</li>
          <li><strong>Estabilidade Jurídica e Política:</strong> Com um sistema legal previsível e o Tribunal de Chancelaria especializado em disputas empresariais, Delaware garante decisões rápidas e eficientes.</li>
        </ul>

        <h5>Facilidade de Operação:</h5>
        <ul>
          <li><strong>Incorporação Rápida e Simples:</strong> O processo de registro é ágil, podendo ser concluído em apenas um dia.</li>
          <li><strong>Mínima obrigatoriedade de Entrega de Relatórios e Custos Acessíveis:</strong> Menos burocracia e relatórios financeiros, com uma taxa de franquia anual acessível.</li>
        </ul>

        <h5>Proteção de Ativos e Segurança Jurídica:</h5>
        <ul>
          <li><strong>Proteção Robusta para os Membros:</strong> Há separação entre bens pessoais e ativos da LLC, oferecendo proteção patrimonial.</li>
          <li><strong>Sem Restrições sobre Movimentação de Fundos:</strong> Fundos podem ser transferidos livremente dentro e fora do estado.</li>
        </ul>

        <h5>Infraestrutura Profissional de Classe Mundial:</h5>
        <ul>
          <li><strong>Especialização em Negócios:</strong> Delaware conta com uma rede de profissionais experientes que oferecem suporte jurídico, contábil e financeiro para empresas.</li>
        </ul>

        <h5>Conclusão:</h5>

        <p>Delaware oferece tudo o que você precisa para criar e expandir uma empresa de sucesso: benefícios fiscais excepcionais, proteção legal robusta, um ambiente de negócios ágil e uma infraestrutura especializada.</p>

        <p><strong>Se você está buscando uma jurisdição que combine flexibilidade, segurança e eficiência, Delaware é a escolha certa para sua LLC.</strong></p>

        <p>Incorpore sua empresa em Delaware hoje mesmo e aproveite todas as vantagens que o estado tem a oferecer para empresas globais.</p>
      `,

      lblInstructionForBecause:
        'Esta informação é fornecida como um guia para os clientes, pois auxiliamos mais de 1.000 usuários na criação de empresas offshore nesta jurisdição.',
      lblIncorpIn: 'Incorporar nas',
      lblIncorp: 'Incorporar em',
      lblSelectAddons: 'Selecionar Seus Complementos',
      lblBilling: 'Faturamentos e Pagamentos',
      lblAnnualRenewal: 'Renovação Anual',
      lblAnnualFee: 'Taxa Anual',
      lblWhatIsAnnualFee: 'O que é a Taxa Anual?',
      lblAnnualFeeIncludes: 'A Taxa Anual Inclui:',
      lblAnnualFeeInclude1: 'Manutenção do registro da empresa',
      lblAnnualFeeInclude2: 'Organização e Gestão de Documentos da Empresa',
      lblAnnualFeeInclude3: 'Conformidade regulatória',
      lblAnnualFeeInclude4: 'Suporte administrativo',
      lblWhyAnnualFeeImportant: 'Por que a Taxa Anual é Importante?',
      lblCompliance: 'Conformidade',
      lblLegalStatus: 'Status Legal',
      lblBusinessContinuity: 'Continuidade dos Negócios',
      lblReadyToProceed: 'Pronto para Prosseguir',
      lblPrefereces: 'Preferências',
      lblPreferences: 'Preferências',
      lblEnvironmentSetup: 'Configuração de Ambiente',
      lblPaymentStatus: 'Status de pagamento',
      lblEnquiry: 'Suporte',
      lblDetails: 'Detalhes',
      lblViewDetails: 'Ver Detalhes',
      lblAddons: 'Complementos',
      lblAddon: 'Complemento',
      lblNoAddons: 'Sem Complementos',
      lblRepeatPassWord: 'Repita sua senha',
      lblCardholderName: 'Nome do Titular do Cartão *',
      lblExpiration: 'Validade',
      lblCardNumber: 'Número do Cartão',
      lblDebitCard: 'Cartão de Débito',
      lblPaymentDetails: 'Detalhes de Pagamento',
      lblPayYourRequest: 'Pague sua solicitação',
      lblShareholder: 'Acionista',
      lblMembers: 'Membros',
      lblUploadCertificates: 'Enviar Documentos da Empresa',
      // Upload individual de documentos
      selectFileFirst: 'Por favor, selecione um arquivo primeiro',
      selectDateFirst: 'Por favor, selecione uma data de emissão primeiro',
      uploaded: 'Enviado',
      download: 'Baixar',
      documentUploadedOn: 'Enviado em',
      fileName: 'Arquivo',
      fileSelected: 'Arquivo selecionado',
      moreFiles: 'mais arquivos',
      uploading: 'Enviando...',
      uploadThisDocument: 'Enviar Este Documento',
      documentAlreadyUploaded: 'Documento já enviado',
      uploadStatus: 'Status do Upload',
      documentsUploaded: 'documentos enviados',
      requiredDocumentsUploaded: 'documentos obrigatórios enviados',
      allRequiredDocumentsUploaded: 'Todos os documentos obrigatórios foram enviados',
      readyToApprove: 'Pronto para aprovar a empresa',
      sealCopyNotRequired: 'Este documento não é obrigatório para aprovação',
      uploadRemaining: 'Enviar Documentos Restantes',
      noFilesSelected: 'Nenhum arquivo selecionado para os documentos restantes',
      allDocumentsUploaded: 'Todos os documentos foram enviados',
      documentUploadedSuccessfully: 'Documento enviado com sucesso',
      // Status de documentos
      approved: 'Aprovado',
      pending: 'Pendente',
      rejected: 'Rejeitado',
      notUploaded: 'Não Enviado',
      // Upload de documentos específicos
      uploadDocument: 'Enviar Documento',
      uploadAddress: 'Enviar Endereço',
      uploadDocumentDescription: 'Enviar um documento para este acionista',
      uploadPassportDescription: 'Enviar um passaporte para este acionista',
      uploadAddressDescription: 'Enviar um documento de endereço para este acionista',
      registrationCompleted: 'Registro Concluído',
      documentSuccessfullyUploaded: 'Documento enviado com sucesso',
      uploadNewVersion: 'Enviar Nova Versão',
      clickToUploadNewVersion: 'Clique para enviar uma nova versão',
      uploadedDocuments: 'Documentos Enviados',
      sending: 'Enviando...',
      sendRegistrationData: 'Enviar Dados de Registro',
      registrationStatus: 'Status do Registro',
      completed: 'Concluído',
      lblInputFirstMessage: 'Insira a primeira mensagem',
      lblMyFirstMessageIs: 'Minha primeira mensagem é...',
      lblSendMessage: 'Enviar uma mensagem',
      lblReasonForMoreInfo: 'Motivo para mais informações',
      lblCompanyInfo: 'Informações da Empresa',
      lblMailroom: 'Sala de Correspondência',
      lblContactUs: 'Fale Conosco',
      lblRegistrationNo: 'Número de Registro',
      lblNoRegistrationNumber: 'Sem Número de Registro',
      lblCompanyStatus: 'Situação da Empresa',
      lblIncorporationDate: 'Data de Constituição',
      lblViewMore: 'Ver mais',
      lblCompanyDocuments: 'Documentos da Empresa',
      lblNoDocuments: 'Você não tem documentos',
      lblNoNotifications: 'Você não tem notificações',
      lblNoNameDocument: 'Documento sem título',
      lblPdfDocument: 'Documento PDF',
      lblSubscriberType: 'Tipo de Assinante',
      lblSubscriberName: 'Nome do Assinante',
      lblDocumentationStatus: 'Status da documentação',
      lblDocument: 'Documento',
      lblAnalyzeDocuments: 'Ver Documentos',
      lblDirectorsAndShareholders: 'Diretores e Acionistas',
      lblCompanySecretary: 'Secretário da Empresa',
      lblAccounting: 'Contabilidade',
      lblRequests: 'Solicitações',
      lblOnGoing: 'Em andamento',
      lblCompanyDetails: 'Detalhes da Empresa',
      lblCompanyName: 'Sua empresa',
      lblFinancialYear: 'Ano Fiscal',
      lblDirectors: 'Diretores',
      lblAddress1: 'Endereço 1 *',
      lblAddress2: 'Endereço 2',
      lblPostalCode: 'Código Postal *',
      lblCity: 'Cidade *',
      lblState: 'Estado *',
      lblNeighborhood: 'Bairro *',
      lblCountry: 'País',
      lblEconomicSubstance: 'Substância Econômica',
      lblPrincipalActivity: 'Atividade primária',
      lblMainActivities: 'Atividades principais',
      lblSecondaryActivity: 'Atividade Secundária',
      lblShareName: 'Nome das Ações',
      lblTotalPaidUpCapital: 'Capital Integralizado Total',
      lblTotalIssuedShareCapital: 'Capital Social Emitido Total',
      lblTotalNumberOfShares: 'Número Total de Ações',
      lblSelectChat: 'Selecionar um Chat para ver novas mensagens',
      lblSearchPeople: 'Pesquisar usuário',
      lblTypeHere: 'Digite aqui...',
      lblSearchCompany: 'Buscar empresa...',
      lblSearchEmail: 'Buscar email...',
      lblGeneralDocuments: 'Documentos Gerais',
      lblDocumentName: 'Nome do Documento',
      lblMessageStatus: 'Mensagem',
      lblView: 'Visualizar',
      lblType: 'Tipo',
      lblRole: 'Cargo',
      lblDatePosted: 'Data de Publicação',
      lblStatus: 'Status',
      lblActions: 'Ações',
      lblID: 'ID',
      lblTotalDocuments: 'Total Documentos',
      lblInputInformationDirectors: 'Por favor, forneça as informações do diretor',
      lblDirector: 'Diretor',
      lblPendingUploadFile: 'Aguardando envio de arquivo',
      lblCompleted: 'Concluído',
      lblDirectorShareholder: 'Diretor/Acionista',
      lblNoDataAvailable: 'Não há dados disponíveis',
      lblNoDirectorsOrShareholders: 'Nenhum diretor ou acionista cadastrado ainda.',
      lblTransferCompany: 'Empresa de transferência',
      lblPage: 'Página',
      lblNextPage: 'Próxima',
      lblPevPage: 'Anterior',
      lblToNextPage: 'De',
      lblGender: 'Gênero *',
      lblGenderMale: 'Masculino',
      lblGenderFemale: 'Feminino',
      lblDateOfBirth: 'Data de Nascimento (aaaa/mm/dd)*',
      lblPhone: 'Telefone*',
      lblPhoneLess: 'Telefone',
      lblNationality: 'País de nascimento *',
      lblPassportNo: 'Número do Passaporte*',
      lblExpiryDate: 'Data de Vencimento do Passaporte (aaaa/mm/dd)*',
      lblPassportIssuingCountry: 'País de Emissão do Passaporte*',
      lblIssueDate: 'Data de Emissão do Passaporte (aaaa/mm/dd)*',
      lblIssueDateLess: 'Data de Emissão',
      lblUploadDirectorsDocuments: 'Carregar documento do diretor',
      lblUploadShareholdersDocuments: 'Carregar documentos do acionista',
      lblUploadMembersDocuments: 'Carregar documentos dos membros',
      lblPassport: 'Passaporte',
      lblLocalDocument: 'Identidade Nacional',
      lblProveAddress: 'Comprovante de Residência',
      lblPersonalDocuments: 'Documentos Pessoais',
      lblNoCompanyDocumentsDescription: 'Nenhum documento da empresa foi enviado ainda.',
      lblSigned: 'Assinado',
      lblUnsigned: 'Não Assinado',
      lblNextStep: 'Próxima Etapa',
      lblPushYourDocument: 'Enviar documento',
      lblClickToUpload: 'Clique para enviar',
      lblUpload: 'Enviar',
      lblSuccessYourDocument: 'Documento enviado com sucesso',
      lblOrSearchInYourComputer: 'ou pesquisar em seu computador',
      lblDocumentsSupported: 'Documentos Suportados: PDF ou DOC | Tamanho Máximo: 30MB',
      passportExpired: 'Passaporte Vencido',
      expiresIn: 'Vence em',
      days: 'dias',
      valid: 'Válido',
      email: 'Email',
      passportNo: 'Número do Passaporte',
      passportExpiry: 'Vencimento do Passaporte',
      datePosted: 'Data de Postagem',
      uploadNewPassport: 'Carregar Novo Passaporte',
      renewPassport: 'Renovar Passaporte',
      unnamed: 'Sem nome',
      noEmail: 'Sem email',
      noPassport: 'Sem passaporte',
      unknown: 'Desconhecido',
      noDirectorsOrShareholders: 'Nenhum Diretor ou Acionista',
      noDirectorsOrShareholdersAdded: 'Nenhum diretor ou acionista foi adicionado ainda.',
      // Passport Upload Modal
      passportUploadTitle: 'Carregar Novo Passaporte',
      passportUploadDescription: 'Carregue um novo documento de passaporte para {{name}}.',
      uploadPassportDocument: 'Carregar Documento do Passaporte',
      uploadPassportDocumentDescription: 'Carregar seu documento de passaporte',
      documentUpload: 'Upload de Documento',
      passportInformation: 'Informações do Passaporte',
      passportNumber: 'Número do Passaporte',
      expiryDate: 'Data de Vencimento',
      issueDate: 'Data de Emissão',
      passportIssuingCountry: 'País de Emissão do Passaporte',
      selectCountry: 'Selecione um país',
      passportDocument: 'Documento do Passaporte',
      uploadYourDocument: 'Carregue seu documento',
      orSearchInComputer: 'ou pesquise no seu computador',
      supportedFormats: 'Formatos suportados: PDF ou DOC | Tamanho máximo: 3MB',
      uploadPassport: 'Carregar Passaporte',
      passportUpdatedSuccessfully: 'Passaporte atualizado com sucesso',
      passportNumberRequired: 'Número do passaporte é obrigatório',
      issuingCountryRequired: 'País de emissão é obrigatório',
      issueDateRequired: 'Data de emissão é obrigatória',
      passportFileRequired: 'Arquivo do passaporte é obrigatório',
      lblDocumentsSupportedEnquiry: 'Documentos Suportados: IMG or PDF | Tamanho Máximo: 5MB',
      lblInputInformationShareholders: 'Forneça informações do acionista',
      lblInputInformationMembers: 'Por favor, forneça informações dos membros',
      lblShareDetails: 'Detalhes das Ações',
      lblShareIssuanceDate: 'Data de Emissão das Ações (aaaa/mm/dd)*',
      lblClassOfShares: 'Classe de Ações',
      lblSelectClassShare: 'Selecione uma classe de ações',
      lblSeriesOfShares: 'Série de Ações*',
      lblPrivilegesRestrictions: 'Privilégios/Restrições (se houver)',
      lblConditions: 'Condições (se houver)',
      lblRequestsBar: 'Solicitações',
      lblTypeDocuments: 'Tipo',
      lblAdditionalSelect: 'Selecione sua Jurisdição',
      lblWeveHelped: 'Já ajudamos mais de 1000 clientes a abrir empresas offshore',
      lblBackToHomePage: 'Ir para Homepage',
      lblAdminModeSkipPayment: 'Modo admin: pular pagamento',
      lblSelectYourCompany: 'Selecione sua empresa',
      lblSelect: 'Selecione',
      lblSelectType: 'Selecione o tipo',
      lblReset: 'Resetar',
      lblPrimaryColor: 'Cores Principais',
      lblButtonColor: 'Cores Botões',
      lblBorderColor: 'Cores Bordas',
      lblSelectStatus: 'Selecionar Status',
      lblLoading: 'Carregando',
      lblNoRecords: 'Nenhum registro encontrado',
      lblExactDateFilter: 'Buscar por data exata',
      lblExactDate: 'Data exata',
      activeFilters: 'Filtros Ativos',
      resultsFound: 'resultados encontrados',
      lblDueDate: 'Data de Vencimento',
      lblAmount: 'Valor',
      lblRenewalAddonsTitle: 'Adicione extras à sua renovação',
      lblRenewalAddonsDescription: 'Como você está renovando, você também pode adicionar serviços ou recursos extras à sua empresa. Estes são opcionais e podem ser alterados posteriormente.',
      lblStartingFrom: 'A partir de',
      lblNoCompanyName: 'Sem nome de empresa definida',
      lblCorporateDirector: 'Diretor Corporativo',
      lblIncluded: 'Incluído',
      
      // Director/Shareholder Dashboard
      lblMyProfile: 'Meu Perfil',
      lblViewAndEdit: 'Visualize e edite suas informações',
      lblProfileComplete: 'Perfil Completo',
      lblViewProfile: 'Ver Perfil',
      lblMyDocuments: 'Meus Documentos',
      lblDocumentStatus: 'Verifique o status dos seus documentos',
      lblSubmitted: 'Documentos Enviados',
      lblComingSoon: 'Em Breve',
      lblYourCurrentStatus: 'Seu status atual',
      lblActive: 'Ativo',
      lblViewYourDocuments: 'Ver Documentos',
      lblNoDocumentsDescription: 'Você ainda não enviou nenhum documento.',
      lblDocuments: 'documentos',
      lblUntitledDocument: 'Documento Sem Título',
      lblUploadedOn: 'Enviado em',
      lblDownload: 'Baixar',
      lblApproved: 'Aprovado',
      lblRejected: 'Rejeitado',
      lblPending: 'Pendente',
      lblPassports: 'Passaportes',
      lblIssuingCountry: 'País Emissor',
      lblAddressDocuments: 'Documentos de Endereço',
      lblAddressProof: 'Comprovante de Endereço',
      lblDocumentsInfo: 'Os documentos são revisados por nossa equipe. Você será notificado assim que a revisão for concluída.',
      lblNoCompanyLinked: 'Nenhuma Empresa Vinculada',
      lblNoCompanyLinkedDescription: 'Você não está vinculado a nenhuma empresa no momento. Entre em contato com o suporte se acreditar que isso é um erro.',
      lblAboutDirectorDashboard: 'Sobre o Dashboard de Diretor/Acionista',
      lblDirectorDashboard: 'Dashboard de Diretor/Acionista',
      lblDirectorDashboardDescription: 'Este dashboard permite que você visualize e gerencie suas informações pessoais como diretor ou acionista. Você pode atualizar seus dados, visualizar seus documentos e acompanhar seu status.',
      lblRecentUpdates: 'Atualizações recentes',
      lblAllCaughtUp: 'Você está em dia!',
      lblViewAll: 'Ver Tudo',
      
      // Profile Page
      lblManageYourPersonalInfo: 'Gerencie suas informações pessoais',
      lblEdit: 'Editar',
      lblSave: 'Salvar',
      lblSaving: 'Salvando...',
      lblPersonalInformation: 'Informações Pessoais',
      lblBirthDate: 'Data de Nascimento',
      lblAddress: 'Endereço',
      lblStreet: 'Rua',
      lblZipCode: 'CEP',
      lblOfficialDocuments: 'Documentos Oficiais',
      lblPassportNumber: 'Número do Passaporte',
      lblTaxId: 'CPF/Tax ID',
      lblClickEditToUpdate: 'Clique no botão "Editar" para atualizar suas informações'
    },
    // Campos
    fields: {
      fldConfirmPwdPlaceholder: 'Exemplo: 12345#!2',
      fldEmailPlaceholder: 'Exemplo: Ariel@offshore2go.com',
      fldLastNamePlaceholder: 'Exemplo: Souza',
      fldFirstNamePlaceholder: 'Exemplo: Ariel',
      fldPronounPlaceholder: 'Selecione seu pronome',
      fldSelectYourOption: 'Selecione sua opção',
      fldPwdPlaceholder: 'Exemplo: 12345#!2',
      fldFieldNumber: 'O campo deve ser um número',
      fldOnboarding: 'Integração'
    },

    // Títulos
    titles: {
      ttlResetPwd: 'Redefinir sua senha',
      ttlCreateAccount: 'Criar sua conta',
      ttlDefineObjectives: 'Selecione seus principais objetivos',
      ttlChooseObjectives: 'Qual é o seu principal objetivo?',
      ttlCreateNewOffshore: 'Quero criar uma nova Offshore',
      ttlTransferExistingOffshore: 'Quero transferir uma Offshore existente',
      ttlSummary: 'Resumo da sua compra',
      ttlOffshorePackage: 'Seu pacote Offshore2Go',
      ttlDirectorsCount: 'Quantos diretores sua offshore terá?',
      ttlJurisdiction: 'Definir sua jurisdição',
      ttlAddons: 'Por favor, selecione os complementos',
      ttlShareholderCount: 'Quantos acionistas sua offshore terá?',
      ttlShareholderUnderagesCount: 'Quantos destes acionistas são menores de 18 anos?',
      ttlMembersCount: 'Quantos membros seu offshore terá?',
      ttlMembersUnderagesCount: 'Quantos membros?',
      ttlMinorsCount: 'Quantos são menores de idade?',
      ttlConfirmation: 'Sua confirmação',
      ttlNotFound: 'Página não encontrada',
      ttlInstructionCardTitle: 'Instrução para você',
      ttlFinishRegister: 'Finalize seu cadastro',
      ttlButtonInformation:
        ' Você precisa assinar o contrato de usuário. Caso já tenha assinado o documento, aguarde alguns instantes e atualize a página novamente.',
      ttlSigned: 'Assinado', 
      ttlAlertContract:
        'Antes de dar continuidade ao seu cadastro, precisamos que assine o contrato de usuário com a Offshore2go. Por favor clique no botão abaixo para ser redirecionado para nosso parceiro Forsign e assine o contrato digitalmente. Caso já tenha realizado a assinatura, por favor aguarde ou atualize a página.',
      ttlSignTheContract: 'Baixar documentos',
      ttlDownload: 'Baixar',
      ttlDownloadDocument: 'Baixar documento',
      ttlVerifySignatures: 'Verificar assinaturas',
      ttlButtonSignTheContract: 'Você deve assinar o contrato de usuário antes de finalizar seu cadastro.',
      ttlButtonSignTheContractNew: 'Assinar contrato',
      ttlButtonDownloadCertificated: 'Baixe seu certificado',
      ttlttlButtonDownloadCertificatedHover:
        'Você poderá fazer o download do seu certificado quando sua empresa for aprovada.',
      ttlButtonDownloadCertificatedIncorporation: 'Baixar certificado de incorporação',
      ttlHello: 'Olá',
      ttlWelcome: 'Bem-vindo',
      ttlSelectCompany: 'Selecione a empresa',
      ttlHome: 'Início',
      ttlSubTituloInitial: 'INICIAL',
      ttlCompany: 'EMPRESA',
      ttlConfig: 'CONFIGURAÇÂO',
      ttlEditPassWord: 'Edite sua senha',
      ttlEnquiryPage: 'Em que podemos ajudar?',
      ttlEnquirySelect: 'Assunto',
      ttlEnquiryMessage: 'Mensagem',
      ttlEnquiryAttachment: 'Anexo',
      ttlThereNoRecords: 'Ainda não existem registros.',
      ttlCustomizeMyPlatform: 'Personalize minha plataforma',
      ttlBasicConfig: 'Configuração Básica',
      ttlTooltipFormatImg: 'Atenção: A logo da Offshore2go deve ter as dimensões de 798x155 pixels para melhor visualização. Formatos permitidos: PNG, JPG, JPEG e SVG.',
      ttlCLickOrDropDocuments: 'Clique ou arraste arquivos para enviar',
      ttlAnnualFeeIntro: 'Bem-vindo ao processo de renovação anual da sua empresa!',
    },
    descriptions: {
      PageAddonsDescription: 'Não se preocupe, você pode alterar suas preferências a qualquer momento',
      Directors: 'Diretores',
      CorporateDirector: 'Diretor Corporativo',
      Shareholder: 'Acionista',
      OperationalCompany: 'Empresa Operacional',
      Startup: 'Startup',
      CommingSoon: 'Em breve',
      ServicesDays: 'Dias',
      Members: 'Membros',
      renewalAddonsDescription: 'Já que você está renovando, pode aproveitar para adicionar serviços ou funcionalidades extras à sua empresa. Isso é opcional e pode ser alterado depois.',
      annualFeeIntroText: 'Nos próximos passos, você poderá revisar as informações da sua offshore e, se desejar, incluir addons que agregam valor ao seu negócio.\nAo final, você será direcionado para o pagamento da taxa anual correspondente à jurisdição da sua empresa.\nVamos começar?',
    },

    config: {
      TabFees: 'Taxas Padrão',
      TabAddons: 'Complementos',
      TabDirectors: 'Diretores e Acionistas',
      TabJurisdictions: 'Jurisdições',
      TargetJuridiction: 'Jurisdição alvo',
      ColorPrimary: 'Primária',
      ColorSecondary: 'Secundária',
      ColorTertiary: 'Terciária',
      Logo: 'Tipo de logo',
      UploadImageFile: 'Envie o arquivo de imagem',
      Active: 'Ativo',
      DirectorFee: 'Taxa de Diretor',
      ShareholdersFee: 'Taxa de Acionista',
      CorporateDirectorFee: 'Taxa de Diretor Corporativo',
      tooltipDirectorFee: 'Valor cobrado por cada diretor pessoa física nomeado na empresa. É o valor que o cliente paga por cada pessoa natural que atua como diretor.',
      tooltipCorporateDirectorFee: 'Valor cobrado pela nomeação de um diretor corporativo (uma empresa que atua como diretor). Usado em estruturas ou serviços de nominado.',
      tooltipShareholdersFee: 'Valor cobrado por cada acionista. É o valor que o cliente paga por cada pessoa ou entidade que detém quotas na empresa.'
    },
    environment: {
      manageAddons: 'Gerenciar Add-ons',
      styleSaved: 'Estilo salvo',
      removeImage: 'Remover imagem',
      logoPreview: 'Pré-visualização do logo',
      selectColor: 'Selecionar cor',
      errorSavingFees: 'Erro ao salvar taxas.',
      noChangesToSave: 'Nenhuma alteração para salvar.',
      errorSavingAddons: 'Erro ao salvar add-ons.',
      errorUpdatingJurisdiction: 'Erro ao atualizar jurisdição.',
      jurisdictionUpdatedSuccess: 'Jurisdições atualizadas.',
      addonsUpdatedSuccess: 'Add-ons atualizados com sucesso!',
      stylesUpdatedSuccess: 'Estilos atualizados com sucesso.',
      logoUploadedSuccess: 'Logo enviada com sucesso!',
      feesUpdatedSuccess: 'Taxas atualizadas com sucesso.',
      userNotAuthenticated: 'Usuário não autenticado.',
      errorFetchingAddons: 'Erro ao buscar add-ons.',
      errorUpdatingFee: 'Erro ao atualizar taxa.',
      errorFetchingPlanInfo: 'Erro ao buscar informações do plano.',
      errorFetchingDirectorsShareholdersConfig: 'Erro ao buscar configuração de diretores/acionistas.'
    },
    
    messages: {
      msgCompanyAproved: 'Empresa concluída e aprovada com sucesso',
      msgFileSizeError: 'O arquivo deve ter no máximo 3MB',
      registrationDataSent: 'Dados de registro enviados com sucesso',
      profileUpdatedSuccessfully: 'Perfil atualizado com sucesso',
      errorUpdatingProfile: 'Erro ao atualizar o perfil. Por favor, tente novamente.',
      errorLoadingDocuments: 'Erro ao carregar documentos. Por favor, tente novamente.',
      errorLoadingCompanies: 'Erro ao carregar empresas. Por favor, tente novamente.',
      passwordChangedSuccessfully: 'Senha alterada com sucesso',
      errorLoadingProfile: 'Erro ao carregar dados do perfil. Por favor, tente novamente.',
      msgDirectorsInstruction:
        'Nossa equipe com 25 anos de experiência ajudou mais de 1.000 usuários a estabelecer empresas nas Bahamas, Ilhas Cayman, Belize e Delaware, entre outras jurisdições.',
      msgShareholdersInstruction:
        'Nossa equipe com 25 anos de experiência ajudou mais de 1.000 usuários a estabelecer empresas nas Bahamas, Ilhas Cayman, Belize e Delaware, entre outras jurisdições.',
      msgConfirmInstruction:
        'Nossa equipe com 25 anos de experiência ajudou mais de 1.000 usuários a estabelecer empresas nas Bahamas, Ilhas Cayman, Belize e Delaware, entre outras jurisdições.',
      filterActive: 'Filtros Ativos',
      noAddonsAvailable: 'Não há complementos disponíveis para este item.',
      annualRenewalIntro: 'Entenda a anuidade e por que manter sua empresa em situação ativa é essencial.',
      annualFeeDescription: 'A taxa anual é um pagamento obrigatório que deve ser realizado anualmente para manter sua empresa offshore ativa e em conformidade com as regulamentações locais.',
      annualFeeBenefits: 'Esta taxa garante que sua empresa mantenha seu status legal e continue operando sem interrupções.',
      complianceDescription: 'Mantém sua empresa em conformidade com as leis e regulamentações da jurisdição.',
      legalStatusDescription: 'Preserva o status legal da sua empresa e evita penalidades.',
      businessContinuityDescription: 'Garante que suas operações continuem sem interrupções.',
      proceedDescription: 'Agora você pode prosseguir para ver os detalhes da sua taxa anual e selecionar serviços adicionais.',
      showingResults: 'Mostrando',
      results: 'resultados',
      showingRange: 'Mostrando {{from}} - {{to}} de {{total}} resultados',
      pageInfo: 'Página {{current}} de {{last}}',
      documentUploadedSuccessfully: 'Documento enviado com sucesso'
    },

    validations: {
      valRequired: 'Preencha este campo',
      required: 'Este campo é obrigatório',
      valPwdRule: 'Deve conter 8 caracteres, uma maiúscula, uma minúscula, um número e um caractere especial',
      valPwdAdvice: 'Deve conter 8 caracteres, uma maiúscula, uma minúscula, um número e um caractere especial',
      valInvalidEmail: 'Endereço de e-mail inválido.',
      valPwdMustMatch: 'As senhas devem coincidir',
      valEmailValid: 'Você deve fornecer um endereço de e-mail válido',
      valFileTypeError: 'O arquivo deve ser um PDF ou DOCX',
      valObjectivesRequired: 'Pelo menos 1 objetivo deve ser selecionado',
      valMustbeNumber: 'O número de acionistas é obrigatório',
      valNumberShareholders: 'O número de menores de idade deve ser menor que o dos acionistas',
      valMustZero: 'deve ser maior que zero',
      valAttetion: 'Atenção',
      valStayTuned: 'Em breve!! Fique atento!',
      valUnoDirector: 'Deve ser selecionado pelo menos um diretor',
      valMaxDirectors: 'O número máximo de diretores é 8',
      valUnoShareholder: 'Deve ser selecionado pelo menos um acionista',
      valMaxShareholders: 'O número máximo de acionistas é 8',
      valTitleNotificion: 'Notificações',
      valSubtituloNotificacion: 'Não há notificações',
      valReadAll: 'Ler todas',
      valExpiryDate: 'Data de expiração inválida. Tempo minímo de 6 meses a partir de hoje.',
      valIncorporationDateMinDate: 'A data de incorporação não deve ser inferior a 1 semana',
      valMinAge: 'Você deve ser ter pelo menos 18 anos de idade',
      valInvalidDate: 'Formato de data inválido',
      valEnquirySelect: 'consulta é obrigatório',
      valEnquiryMessage: 'Mensagem é obrigatório',
      valEnquiryMaxMessage: 'A mensagem não pode ter mais de 100 caracteres',
      valRequiredJurisdictionStructure: 'Deve ser selecionado um tipo de empresa',
      valRequiredJurisdictions: 'Deve ser selecionado pelo menos uma jurisdicao',
      valFieldsEmpty: 'Campos obrigatórios estão vazios.',
      valValidationFailed: 'Validação falhou.'
    },

    errorMessage: {
      errMessAddRequest:
        'This service request is already open for this company, please check the On-Going tab to check the status',
      errMessStepRegisterShareholders: 'Todos os Acionistas ainda não foram registrados.',
      errMessStepRegisterDirectors: 'Todos os Diretores ainda não foram registrados.',
      errMessStepRegisterMembers: 'Todos os Membros ainda não foram registrados.',
      errMessUnexpected: 'Ocorreu um erro inesperado. Tente novamente.'
    },

    buttons: {
      btnBack: 'Voltar',
      btnRegister: 'Registrar',
      btnSave: 'Salvar',
      btnNext: 'Próximo passo',
      btnSendMessage: 'Envie sua mensagem',
      btnSending: 'Enviando...',
      btnEdit: 'Editar',
      btnResetPwd: 'Redefinir senha',
      btnLogin: 'Entrar',
      btnGoToDashboard: 'Go to dashboard',
      btnGoBack: 'Voltar',
      btnContinueToCheckout: 'Continuar para pagamento',
      btnIgnoredCheckout: 'Pular o pagamento',
      btnLogOut: 'Sair',
      btnResetPassWord: 'Redefinir senha'
    },

    documents: {
      proofOfAddress: 'Comprovante de endereço',
      passport: 'Passaporte',
      localDocument: 'Documento nacional (CPF / RG / CNH)',
      passportExpired: 'Passaporte vencido (há {{days}} dias)',
      passportNearExpiry: 'Expira em {{days}} dias',
      passportValid: 'Passaporte válido (expira em {{days}} dias)',
      passportExpiry: 'Validade: {{date}}',
      uploadPassport: 'Enviar passaporte'
    },

    actions: {
      retry: 'Tentar Novamente',
      refresh: 'Atualizar',
      clearFilters: 'Limpar Filtros',
      markAsPaid: 'Marcar como Pago',
      generateInvoice: 'Gerar Fatura',
      close: 'Fechar',
      removeFilter: 'Remover filtro'
    },

    errors: {
      fetchBillingsFailed: 'Falha ao buscar dados de faturamento',
      rateLimitExceeded: 'Muitas requisições no momento. Por favor, aguarde alguns segundos e tente novamente. Se o problema persistir, recarregue a página.',
      invalidUserIdentification: 'Identificação de usuário inválida'
    },

    statuses: {
      paid: 'Pago',
      pending: 'Pendente',
      overdue: 'Vencido'
    },

    tooltips: {
      tltMinor: 'Número de menores que você deseja',
      tltDirector:
        'Informe o número de diretores que você pretende nomear. Mesmo que você queira contratar um diretor terceirizado, ainda pode nomear diretores próprios.',
      tltShareholder: 'Informe o número total de acionistas.',
      tltShareholderMembers: 'Informar o número total de membros.',
      tltLegalPersonality: 'Ofereceremos uma sugestão de estrutura que poderá atender às suas demandas.',
      tltTotalValue:
        'Todas as cobranças serão realizadas em dólares americanos. Favor consultar sua operadora de cartões de crédito para maiores informações a respeito de câmbio e taxas aplicáveis.',
      tltJurisdictions: 'Selecione a jurisdição de sua preferência na lista abaixo.',
      corporateDirectorDescription: 'Incluir um diretor corporativo na renovação anual da sua empresa.'
    },

    others: {
      othCompanyName: 'Nome da empresa',
      othPreferredName: 'Nome preferido',
      othSecondaryName: 'Nome secundário',
      othOption1: 'Opção 1',
      othOption2: 'Opção 2',
      othOption3: 'Opção 3',
      othNameOptions: 'Opções de nome',
      othNoAccount: 'Não tem uma conta?',
      othForgotPwd: 'Esqueceu a senha?',
      othResetPwdInstruction: 'Informe seu e-mail para receber as instruções de redefinição de senha.',
      othChangePassword: 'Trocar senha',
      othChangePasswordDescription: 'Por favor, insira sua nova senha abaixo.',
      othProcessing: 'Processando...',
      othPasswordChangedSuccess: 'Senha alterada com sucesso!',
      othHireCorpDirector: 'Quero contratar um diretor corporativo',
      othOrText: 'ou',
      othPaymentSuccess: 'Pagamento efetuado com sucesso!',
      othPaymentFailed: 'Erro ao realizar pagamento! Tente novamente mais tarde',
      othRegistering: 'Registro',
      othCompanies: 'Empresas',
      othCompany: 'Empresa',
      otheNewCompany: 'Novas Empresas',
      otheTransferredCompanies: 'Empresas Transferidas',
      othDirectors: 'Diretor',
      othShareholders: 'Acionista',
      otheShareholdersAndDirectors: 'Diretores e Acionistas',
      othCompanyDocuments: 'Documentos da Empresa',
      othBusiness: 'Negócio',
      othInformationYourNewCompany: 'Informações da Nova Empresa',
      othIBCPrimaryNameTooltip: `
      Observe que o nome desejado para a empresa pode não estar sempre disponível, pois o nome exato ou alguma variação muito semelhante pode já estar em uso por outra entidade. Por isso, indique abaixo o nome preferido e duas alternativas, na ordem de preferência.O nome da empresa deve terminar em “Limited” ou “Ltd.”, portanto, verifique que essa terminação está incluída em todas as opções de nome escolhidas.Além disso, sua empresa será constituída utilizando exatamente o nome informado abaixo. Assim, preencha o nome exatamente como você deseja que apareça nos seus documentos societários.
      `,
      othIBCPrimaryName: 'Primeira Opção de Nome*',
      othIBCSecondName: 'Segunda Opção de Nome*',
      othIBCThirdName: 'Terceira Opção de Nome*',
      othActivityAddress: 'Endereço do diretor principal *',
      othMainCommercialAddress: 'Endereço Comercial Principal *',
      othPrimaryPhone: 'Telefone Principal *',
      othPrimaryEmail: 'E-mail Principal *',
      othManagerAddress: 'Primeiro Endereço do Gerente *',
      othNumberOfUnits: 'Número de Unidades',
      othNumberOfUnitsTooltip:
        'As unidades de participação (membership units) são frações de propriedade em uma LLC, semelhantes às ações de uma corporation. O número de unidades deve estar entre 1 e 50.000.',
      othNumberOfSharesTooltip:
        'As ações representam a participação na empresa. Informe quantas ações este acionista detém. O número de ações deve estar entre 1 e 50.000.',
      othMaxSharesUnits: 'O limite máximo é 50.000.',
      othCreationDate: 'Data de criação',
      othDoesTheCompanyConductRelevantActivities: 'A empresa realiza atividades relevantes?*',
      othRelevantActivities: 'Atividades Relevantes',
      othNo: 'Não',
      othYes: 'Sim',
      othChooseRelevantActivity: 'Escolha uma atividade relevante *',
      othRelevantActivity: 'Atividade relevante',
      othChooseRelevantActivityTooltip:
        'Por favor, escolha entre as opções abaixo, aquela que melhor se adapta ao propósito do seu offshore',
      othShareCapital: 'Capital Social',
      othShareCapitalLess: 'Capital Social',
      othSelectRelevantActivity: 'Selecione uma atividade relevante',
      othTotalAuthorizedShares: 'Total de Ações Autorizadas *',
      othTotalAuthorizedSharesTooltip:
        'Total de Ações Autorizadas é o número máximo de ações que uma empresa pode emitir conforme estabelecido em seu contrato social.',
      othParValue: 'Valor Nominal',
      othParValueTooltip:
        'O valor nominal de uma ação é o menor preço legal pelo qual uma empresa vende cada uma de suas ações.',
      othTotalIssuedShares: 'Total de Ações Emitidas',
      othTotalIssuedSharesLess: 'Total de Ações Emitidas',
      othNominalValue: 'Valor nominal por ação',
      othTotalIssuedSharesTooltip:
        'O total de ações emitidas refere-se ao número total de ações que uma empresa irá emitir no momento da sua constituição.',
      othCurrency: 'Moeda *',
      othTotalAuthorizedUnits: 'Total de Unidades Autorizadas',
      othTotalIssuedUnits: 'Total de Unidades Emitidas',
      othSelectCurrency: 'Selecione uma moeda',
      othPushYourDocument: 'Envie o seu documento',
      othOrSearchInYourComputer: 'Ou procure no seu computador',
      othDocumentSupported: 'Documentos suportados: PDF ou DOC | Tamanho máximo: 30MB',
      othDashboard: 'Painel de Controle',
      othDashboardLogin: 'Faça seu login',
      othNatureOfBusiness: 'Natureza do Negócio (Substância Econômica)',
      othCategory: 'Categoria',
      othDescription: 'Descrição',
      othDeclarationAndConfirmation: 'Declaração e Confirmação',
      othDeclarationText:
        'Ao marcar a caixa abaixo, eu declaro e confirmo que todas as informações fornecidas por mim neste site são verdadeiras e corretas. Além disso, dou meu consentimento e autorização para que as informações aqui contidas sejam usadas para fins de registro na jurisdição escolhida. Compreendo e aceito que qualquer informação incorreta ou erro causado por meu preenchimento das informações necessárias neste site pode resultar em uma cobrança para mim pela apresentação de uma emenda nos documentos da empresa offshore futura. Além disso, caso ocorram alterações nas informações contidas aqui, informarei a Offshore2go dentro de sete (7) dias úteis',
      othEntityObligedToLawsBahamas: 'A entidade está obrigada a cumprir todas as leis e regulamentos nas Bahamas',
      othIDeclareAndConfirmAsAbove: 'Eu declaro e confirmo como acima.',
      othDocumentsWaitingForApproval: 'Documentos aguardando aprovação',
      othApprovalsBehindSchedule: 'Aprovações atrasadas',
      othDocumentsMissingInfoFromCustomer: 'Documentos sem informações do cliente',
      othDocumentsNewCompany: 'Documentos da nova empresa',
      othExpireProcess: 'Processo de expiração',
      othFilterStatus: 'Filtrar Status',
      othPending: 'Pendente',
      othPendingPayment: 'Pagamento Pendente',
      othRegisterOfNumbers: 'Total',
      othTotal: 'Total',
      othIncorporationFee: 'Taxa de Incorporação',
      othGovernmentFee: 'Taxa Governamental',
      othNotApproved: 'Não Aprovado',
      othNoRegistrationNumber: 'Não definido',
      othNoIncorporationDate: 'Não definido',
      othPleaseProvideReason: 'Por favor, forneça o motivo da rejeição',
      othEnterReason: 'Digite o motivo...',
      othEnterAdditionalDetails: 'Digite detalhes adicionais...',
      othRejectDocument: 'Rejeitar',
      othApproved: 'Aprovado',
      othRegister: 'Registrado',
      othWaitingApproval: 'Esperando aprovação',
      othWaitingForMoreInfo: 'Aguardando Mais Informações',
      othCreated: 'Criado',
      othConfirmed: 'Confirmado',
      othCompleted: 'Pago',
      othRejected: 'Rejeitado',
      othCanceled: 'Cancelado',
      othFailed: 'Fracassado',
      othExpired: 'Expirado',
      othTypePaymentCredit: 'Cartão de crédito',
      othTypePaymentDebit: 'Pagamento Débito',
      othPendingSignature: 'Assinatura pendente',
      othRows: 'Linhas',
      othApprovalDocuments: 'Aprovação de documento',
      othCheckPreApprovedDocument: 'Verificar Documento Pré-aprovado',
      othSearch: 'Buscar',
      othSearchDocument: 'Buscar Documento',
      othSearchUsers: 'Buscar Usuários',
      othUsers: 'Usuários',
      othNewService: 'Novo Serviço',
      othShareholder: 'Acionista (s)',
      othScheduleSpecialist: 'Agendar Especialista',
      othNewUser: 'Novo Usuário',
      othDetails: 'Detalhes',
      othSelectPeriod: 'Selecionar Período',
      othSearchCompany: 'Buscar Empresa',
      othMailroom: 'Sala de Correspondência',
      othServiceConfig: 'Configuração de Serviço',
      othApproveCompany: 'Aprovar Empresa',
      othDocuments: 'Documentos',
      othDirector: 'Diretor(es)',
      othNumberOfShares: 'Número de Ações*',
      othUnderages: 'Menores de Idade',
      othYear: 'Ano',
      othMonth: 'Mês',
      othEnquiry: 'Suporte',
      othExceededTheShareLimit: 'Excedeu o limite de ações',
      othMinValue: 'O limite mínimo é 1',
      othMaxValue: 'O limite máximo é 50.000.',
      othThreeNamesMustDiffer: 'As três opções de nome devem ser diferentes.',
      othRole: 'Função',
      othBeneficialOwner: 'Proprietário Beneficiário',
      othIndividualDirectors: 'Diretores Individuais',
      othCompanyAdmin: 'Administração da Empresa',
      othOrdinary: 'Ordinária',
      othEditDirector: 'Editar Diretor',
      othMakeChangesProfile: 'Faça alterações no seu perfil aqui. Clique em salvar quando terminar.',
      othCompleteRegister: 'Completar registro',
      othStartApproval: 'Iniciar aprovação',
      othViewDocument: 'Visualizar Documento',
      othVisualiseDocument: 'Ver informações da empresa',
      othModalRejected: 'Modal Rejeitado',
      othReasonForRejection: 'Motivo para Rejeição',
      othComplementaryMessage: 'Mensagem Complementar',
      othCancel: 'Cancelar',
      othSave: 'Salvar',
      othModalApproved: 'Modal Aprovado',
      othDocumentApproved: 'Documento Aprovado',
      othDocumentReproved: 'Documento não aprovado',
      othDocumentStatus: 'Status do documento',
      othAreYouSureApprove: 'Tem certeza de que deseja aprovar este documento?',
      othApprove: 'Aprovar',
      othMoreInfo: 'Pedir mais informações',
      othJune: 'Junho',
      othJuly: 'Julho',
      othComplete: 'Completo',
      othNameForAgent: 'Nome',
      othEmailForAgent: 'Email',
      othAlternativeNames: 'Nomes alternativos',
      othDetailsKyc: 'Detalhes KYC',
      othOfTable: 'de',
      othAccordionItem: 'Acionista',
      othDirectorOption: 'diretor',
      othCorporateDirectorOption: 'diretor corporativo'
    },

    options: {
      optPronounSr: 'Sr.',
      optPronounSra: 'Sra.'
    },

    // Create Account Page
    OnboardingCreateAccountPageTitle: 'Crie sua conta',
    OnboardingCreateAccountLabelName: 'Nome',
    OnboardingCreateAccountLabelLastName: 'Sobrenome',
    OnboardingCreateAccountLabelPronoun: 'Pronome',
    OnboardingCreateAccountLabelEmail: 'E-mail',
    OnboardingCreateAccountLabelPassword: 'Senha',
    OnboardingCreateAccountLabelConfirmPassword: 'Confirmar senha',
    OnboardingCreateAccountPlaceholderName: 'Exemplo: Ariel',
    OnboardingCreateAccountPlaceholderLastName: 'Exemplo: Souza',
    OnboardingCreateAccountPlaceholderPronoum: 'Selecione seu pronome',
    OnboardingCreateAccountPlaceholderEmail: 'Exemplo: Ariel@offshore2go.com',
    OnboardingCreateAccountPlaceholderPassword: 'Exemplo: 123#!2',
    OnboardingCreateAccountPlaceholderConfirmPassword: 'Exemplo: 123#!2',
    OnboardingCreateAccountSelectOptionsPronounSr: 'Sr',
    OnboardingCreateAccountSelectOptionsPronounSra: 'Sra',
    OnboardingCreateAccountErrorNameRequired: 'Complete este campo',
    OnboardingCreateAccountErrorLastNameRequired: 'Complete este campo',
    OnboardingCreateAccountErrorEmailRequired: 'Complete este campo',
    OnboardingCreateAccountErrorEmailMustBe: 'Você deve informar um e-mail válido',
    OnboardingCreateAccountErrorPasswordRequired: 'Complete este campo',
    OnboardingCreateAccountErrorConfirmPasswordRequired: 'Complete este campo',
    OnboardingCreateAccountErrorPasswordRule:
      'Deve conter 8 caracteres, uma maiúscula, uma minúscula, um número e um caractere especial.',
    OnboardingCreateAccountErrorConfirmPasswordMustMatch: 'As senhas devem ser iguais',
    OnboardingCreateAccountErrorFileSize: 'O arquivo deve ter no máximo 3MB',
    OnboardingCreateAccountErrorFileType: 'O arquivo deve ser um PDF ou DOCX',
    OnboardingCreateAccountButtonNext: 'Próximo',
    OnboardingCreateAccountButtonBack: 'Voltar',

    // Create Objectives Page
    OnboardingObjectivesPageTitle: 'Defina seus objetivos',
    OnboardingObjectivesLabelLegalPersonality: 'Personalidade legal',
    OnboardingObjectivesLabelMyObjects: 'Meus objetivos são',
    OnboardingObjectivesDefaultSelectOptionLegalPersonality: 'Selecione uma opção',
    OnboardingObjectivesSelectOptionLegalPersonalityIndividual: 'Individual',
    OnboardingObjectivesSelectOptionLegalPersonalityStartup: 'Startup',
    OnboardingObjectivesSelectOptionLegalPersonalityOperationalCompany: 'Operar compania',
    OnboardingObjectivesCheckBoxOptionMyObjectsFinancialInvestment: 'Investimento financeiro',
    OnboardingObjectivesCheckBoxOptionMyObjectsBankAccount: 'Conta bancária',
    OnboardingObjectivesCheckBoxOptionMyObjectsBrokers: 'Corretoras',
    OnboardingObjectivesCheckBoxOptionMyObjectsRealStateInTheUSA: 'Imóveis nos EUA',
    OnboardingObjectivesCheckBoxOptionMyObjectsRaiseCapitalFromInvestors: 'Levantar capital de investidores',
    OnboardingObjectivesCheckBoxOptionMyObjectsPassThroughOperation: 'Operação de passagem',
    OnboardingObjectivesCheckBoxOptionMyObjectsReceiveRevenuesFromCommercialTransactions:
      'Receber lucros de operações comerciais',
    OnboardingObjectivesCheckBoxOptionMyObjectsRoyalties: 'Royalties',
    OnboardingObjectivesSelectOptionErrorMustHave: 'Você deve selecionar pelo menos um objetivo',

    // Onboarding Justification Page
    OnboardingJurisdictionPageTitle: 'Defina sua jurisdição',
    OnboardingJurisdictionBahamasOptionTitle: 'Incorp nas Bahamas',
    OnboardingJurisdictionBahamasOptionDescription: 'Diretor indicado, sala de correspondência e endereço registrado',
    OnboardingJurisdictionBahamasOptionTitleWhyChoose: 'Por que escolhemos esta?',
    OnboardingJurisdictionBahamasOptionTextWhyChoose:
      'Esta é uma instrução para você porque ajudamos mais de 1000 usuários a abrir compras em Cingapura',
    OnboardingJurisdictionBahamasEDelawareOptionTitle: 'Incorp nas Bahamas e Delaware',
    OnboardingJurisdictionBahamasEDelawareOptionDescription:
      'Diretor indicado, sala de correspondência e endereço registrado',
    OnboardingJurisdictionBahamasEDelawareOptionTextWhyChoose:
      'Nossa equipe de 25 anos de experiência ajudou mais de 1.000 usuários a abrir empresas offshore nas Bahamas, Cayman, Belize e Delaware, entre outras jurisdições.',
    OnboardingJurisdictionCaimanEDelawareOptionTitle: 'Incorp em Cayman e Delaware',
    OnboardingJurisdictionCaimanEDelawareOptionDescription:
      'Diretor indicado, sala de correspondência e endereço registrado',
    OnboardingJurisdictionCaimanEDelawareOptionTextWhyChoose:
      'Nossa equipe de 25 anos de experiência ajudou mais de 1.000 usuários a abrir empresas offshore nas Bahamas, Cayman, Belize e Delaware, entre outras jurisdições.',

    // Onboarding Directors Page
    OnboardingDirectorsInstructionCardDescription: 'Nulo',
    OnboardingDirectorsInstructionCardTitle: 'Instrução para você',
    OnboardingDirectorsLabelNumberOfDirectors: 'Número de diretores',
    OnboardingDirectorsOptionHireCorporateDirector: 'Quero contratar um diretor corporativo',
    OnboardingDirectorsPageTitle: 'Quantos diretores sua offshore terá?',
    OnboardingDirectorsTextOr: 'Ou',
    OnboardingDirectorsTooltipNumberOfDirectors: 'Número de diretores que você deseja',

    // Onboarding Shareholders Page
    OnboardingShareholdersInstructionCardDescription: 'Nulo',
    OnboardingShareholdersInstructionCardTitle: 'Nulo',
    OnboardingShareholdersLabelNumberOfMinors: 'Número de menores de idade',
    OnboardingShareholdersLabelNumbersOfshareholders: 'Número de acionistas',
    OnboardingShareholdersPageShareholderTitle: 'Quantos acionistas você terá?',
    OnboardingShareholdersPageUnderageTitle: 'Quantos acionistas menores de idade você terá?',
    OnboardingShareholdersTooltipNumberOfMinors: 'Número de menores de idade',
    OnboardingShareholdersTooltipNumbersOfshareholders: 'Número de acionistas',

    // Onboarding Addons Page
    OnboardingAddonsLabelSelectAddons: 'Selecione os serviços adicionais',
    OnboardingAddonsOptionBasicAccounting: 'Contabilidade básica',
    OnboardingAddonsOptionDigitalMailRoom: 'Sala de correio digital',
    OnboardingAddonsOptionFinancialStatement: 'Demonstrativo financeiro',
    OnboardingAddonsOptionPremiumAccountingServices: 'Serviços de contabilidade premium',
    OnboardingAddonsOptionRegisterAddress: 'Endereço registrado',
    OnboardingAddonsOptionYearlyReviewOfStructure: 'Revisão anual da estrutura',
    OnboardingAddonsPageDescription: 'Não se preocupe, você pode alterar suas preferências a qualquer momento',
    OnboardingAddonsPageTitle: 'Selecione os serviços adicionais',

    // Onboarding Request Page
    OnboardingRequestInitPage: 'Seus pedidos',
    OnboardingRequestWhatDoNeed: 'O que eu preciso?',
    OnboardingRequestProcessingTime: 'Tempo de processamento',
    OnboardingRequestPrice: 'R$',
    OnboardingRequestActionSubmit: 'Crie uma nova solicitação',
    OnboardingRequestActionCheckout: 'Continuar para finalizar a compra',
    OnboardingRequestStepsToExpect: 'Passos a esperar',
    OnboardingRequestLoadingData: 'Carregando...',
    OnboardingRequestCompleteRequest: 'Conclua sua solicitação',
    OnboardingRequestNoData: 'Não há nenhuma solicitação em andamento',
    OnboardingRequestFailed: 'Falha na solicitação',
    OnboardingRequestList: 'Lista de solicitações',
    CLName: 'Nome',
    CLCompanyName: 'Nome da Empresa',
    CLEmail: 'Email',
    CLCreated: 'Criado',
    CLValue: 'Valor',
    CLNumberRegister: 'Registro de Número',
    CLTitle: 'Título',
    CLStatus: 'Status',
    OnboardingDownloadDocument: 'Download do certificado',

    // Summary Page
    OnboardingSummaryButtonContinueToCheckout: 'Continuar para o pagamento',
    OnboardingSummaryPageTitle: 'Resumo da sua compra',

    // PaymentSuccedded
    PaymentSucceddedTitle: 'Pagamento efetuado com sucesso!',
    PaymentSucceddedSubTitle: 'Pagamento efetuado com sucesso!',
    GoToDashboard: 'Ir para o dashboard',

    PaymentProcessingTitle: 'Confirmação de pagamento',
    PaymentProcessingDescription: 'Aguarde enquanto confirmamos seu pagamento...',

    // Others
    OthersSelectYourOption: 'Selecione uma opção',
    OthersOptionsSelect: 'Outros...',
    PackageTitle: 'Seu pacote - ',
    Required: 'Obrigatório',
    ContinueToCheckout: 'Continuar para finalizar a compra',
    checkoutIsSecureTitle: 'Você será redirecionado para um ambiente seguro.',
    Annual: 'Anual',
    checkoutIsSecureText:
      'Estamos comprometidos com a segurança de suas informações e queremos assegurar que sua experiência de pagamento seja totalmente confiável. Ao clicar no botão abaixo, você será redirecionado para o ambiente de pagamento seguro da Stripe, uma plataforma de renome internacionalmente reconhecida por sua integridade protocolos de segurança de alto nível.',
    othersTextCharacter: 'Caracteres',
    PendingPaymentSelectCompany:
      'Ainda não identificamos o pagamento da sua solicitação. Acesse a página de checkout e finalize o pagamento para continuar com a abertura de sua Offshore.',
    BtnPendingPaymentSelectCompany: 'Continue to checkout',
    BtnCreateNewOffshore: 'Criar nova offshore',

    // Alert Messages
    AlertEnquiryMessage: 'O tamanho máximo do arquivo é de 5MB. Por favor tente novamente.',
    AlertFinishYourRegisterTitle: 'Parabéns!',
    AlertFinishYourRegisterMessage:
      'A partir daqui pode relaxar que a Offshore2go cuidará de tudo e em 7 dias sua empresa estará aberta.',
    AlertFinishYourRegisterButton: 'Entendi',
    AlertContractTitle: 'Assine o contrato de usuário',
    // Transfer Company
    companyTransfer: {
      othTitlePageDirectors: 'Por favor insira as informações dos diretores',
      othTitlePageShareholders: 'Por favor insira as informações dos acionistas',
      othTllCompanyRegistering: 'Por favor, conte-nos mais sobre sua empresa',
      othCompanyName: 'Nome da empresa*',
      othNumberRegisterCompany: 'Número de Registro da Empresa',
      othCompleteCompanyRegistration: 'Completar cadastro da empresa',
      othJuridiction: 'Jurisdição*',
      othUpladoDocument: 'Certificado de incorporação',
      othSelectJurisdiction: 'Selecione a jurisdição',
      othCheckCompanyDocument: 'Quero que a Offshore2go recupere os documentos da minha empresa',
      othNumberShareholders: 'Número de acionistas',
      othNumberDirectors: 'Número de diretores',
      othTotalAuthorizedShares: 'Total de ações autorizadas*',
      othTotalIssuedShares: 'Total de ações emitidas',
      othParValue: 'Valor nominal',
      othCurrency: 'Moeda',
      othSelectedCurrency: 'Selecione a moeda',
      othComplementTransfer: 'Complemento',
      othWarningRegisterCompany: 'Você pode prosseguir para o próximo, este já foi concluído',
      othWarningDontRegisterCompany: 'Você pode prosseguir para o próximo, náo precisam preencher este dados',
      othModalTitleInformation: 'Como é que a Offshore2go recupera os meus documentos?',
      othModalInformation:
        'Você pode economizar tempo pagando uma pequena taxa, para não precisar carregar todos os documentos da sua empresa.',
      descriptionText: 'Certificado de Incorporação'
    },
    certificatesDocuments: {
      CERTIFICATE_INCORPORATION: 'Certificado de Incorporação',
      FIRST_DIRECTORS_RESOLUTION: 'Primeira Ata de Reunião de Diretores',
      ACCOUNTING_DECLARATION: 'Declaração Contábil',
      FORM_D: 'Formulário D (Partes Controladoras)',
      SEAL_COPY: 'Cópia do Selo da Empresa',
      MEMORANDUM_ASSOCIATION: 'Memorando de Associação',
      REGISTER_MEMBERS: 'Registro de Sócios',
      REGISTER_DIRECTORS: 'Registro de Diretores',
      CERTIFICATE_SHARES: 'Certificado de Ações',
      CERTIFICATE_COMPLIANCE: 'Certificado de Conformidade',
      'Certificate of Shares': 'Certificado de Ações',
      ARTICLES_ASSOCIATION: 'Estatutos da Empresa',
      Accounting: 'Contabilidade',
      Alterações: 'Alterações',
      Certificados: 'Certificados',
      Certificates: 'Certificados',
      Changes: 'Alterações',
      Constituição: 'Constituição',
      Contabilidade: 'Contabilidade',
      Forms: 'Formulários',
      Formulários: 'Formulários',
      Incorporation: 'Constituição',
      'Other Documents': 'Outros Documentos'
    },
    jurisdictionTitles: {
      bahamas: 'BAHAMAS'
    },
    accountingModule: {
      welcomeAccounting:
        'Bem-vindo ao módulo de Contabilidade! Aqui você pode ver todas as suas informações de transações, conectar-se com sua conta bancária para recuperar o histórico de transações, adicionar transações manuais, gerar um balanço patrimonial e também enviá-lo para revisão de um agente contábil.',
      selectBank: 'Selecione Banco',
      addManualTransactions: 'Adicionar transações manuais',
      connectYourBank: 'Conecte seu banco',
      titleConnectBank:
        'Você será redirecionado para o site da Plaid, onde poderá se registrar e conectar-se com sua conta bancária preferida.',
      infoConnectBank: 'O Offshore2Go poderá: ',
      goConnectBank: ' Ler o histórico de transações',
      btnConnectManual: 'Adicionar Banco Manualmente',
      btnConnectPlaid: 'Conectar com Plaid',
      categoryList: 'Categoria',
      searchCategories: 'Buscar categorias...'
    },
    billingPayments: {
      billingPaymentsSubtitle: 'Visualize e gerencie seus pagamentos e faturas',
      billingPaymentsTitle: 'Faturamento e Pagamentos',
      billingPaymentsFilterDescription: 'Filtre suas transações',
      billingPaymentsSearchPlaceholder: 'Buscar transação',
      billingPaymentsDescription: 'Descrição',
      billingPaymentsAmount: 'Valor',
      billingPaymentsDate: 'Data',
      billingPaymentsPaymentMethod: 'Método de pagamento',
      billingPaymentsStatus: 'Status',
      billingPaymentsType: 'Tipo'
    },
    enquiry: {
      enquirySubtitle: 'Entre em contato conosco e tire suas dúvidas',
      enquiryMessagePlaceholder: 'Digite sua mensagem aqui...'
    },
  accounting: {
    accountingSubtitle: 'Gerencie suas transações e categorias financeiras',
    period: 'Período',
    open: 'Aberto',
    days: 'dias',
    leftToEndMonth: 'restantes para o fim do mês',
    output: 'Saída',
    input: 'Entrada',
    noCategory: 'Sem categoria',
    noTransactionsYet: 'Nenhuma transação registrada ainda',
    featureComingSoon: 'Esta funcionalidade estará disponível em breve'
  },
    KYCDocuments: {
      statusKYC: {
        blocked: 'Rejeitado',
        pending: 'Pendente',
        approved: 'Aprovado'
      },
      detailsKYC: {
        Enforcements: 'Aplicações de Regulamento',
        PEPs: 'Pessoas Politicamente Expostas (PEPs)',
        Source: 'Fonte',
        Country: 'País',
        SubCategories: 'Subcategorias',
        GoverningRole: 'Função Governante',
        ExpirationDate: 'Data de Expiração:'
      },
      notFound: 'Não há restrições para esta pessoa.'
    },
    annualFee: {
      title: 'Configuração da taxa anual (por jurisdição e tipo de empresa)',
      loading: 'Carregando...',
      error: 'Erro ao buscar configurações.',
      noConfig: 'Nenhuma configuração encontrada.',
      companyType: 'Tipo de empresa',
      amount: 'Valor',
      tooltipAmountMin: 'O valor não pode ser inferior ao mínimo atualmente exibido para esta configuração.',
      dueDate: 'Data de vencimento',
      description: 'Descrição',
      save: 'Salvar',
      saving: 'Salvando...',
      saved: 'Salvo!',
      saveError: 'Erro ao salvar.',
      companyTypes: {
        new_company: 'Nova Empresa',
        transfer_company: 'Transferência de Empresa'
      }
    },
    preferences: {
      subtitle: 'Gerencie as configurações e preferências da sua conta',
      profileSettings: 'Configurações de Perfil',
      security: 'Segurança',
      profileInformation: 'Informações do Perfil',
      profileDescription: 'Seus dados pessoais da conta',
      accountMember: 'Usuário',
      fullName: 'Nome Completo',
      emailAddress: 'Endereço de E-mail',
      notProvided: 'Não informado',
      languagePreferences: 'Preferências de Idioma',
      chooseLanguage: 'Escolha seu idioma preferido',
      languageUpdated: 'Idioma atualizado com sucesso',
      updatePasswordDescription: 'Atualize sua senha para manter sua conta segura',
      enterNewPassword: 'Digite a nova senha',
      confirmNewPassword: 'Confirme a nova senha',
      passwordRequirements: 'A senha deve conter pelo menos 8 caracteres, incluindo maiúsculas, minúsculas, números e caracteres especiais.'
    }
  }
};

export default translate_pt;
